import { isEmpty } from '@/utils/general/browserHelper'
import { Container, Typography } from '@cleartrip/ct-design-components'

const EmiBankProMsg = ({ msg = '' }: { msg: string }) => {
    return !isEmpty(msg) ? (
        <Container className="mx-6 py-4" style={{ borderTop: '2px dashed #F3F3F3' }}>
            <Typography variant="P3">{msg}</Typography>
        </Container>
    ) : (
        <></>
    )
}

export default EmiBankProMsg
